export const environment = {
  production: true,
  appInsightsConnectionString: 'InstrumentationKey=04c6d535-ac71-4c17-9aae-d31a214e7ce6;IngestionEndpoint=https://swedencentral-0.in.applicationinsights.azure.com/;LiveEndpoint=https://swedencentral.livediagnostics.monitor.azure.com/;ApplicationId=2f5be81e-69a3-4499-9159-edf05ee5a2d7',
  BASE_URL: 'https://ikserver.kuba.no/api/kuba/v1',
  BASE_URL_V2: 'https://ikserver.kuba.no/api',
  BASE_CRM_URL: 'https://crm.kuba.no/nb/',
  BASE_FRONT_URL: 'https://ik.kuba.no/',
  BASE_ASSET_PATH: '/assets',
  BASE_STYLES_PATH: '/assets/styles',
  NOTIFICATION_URL: 'https://ikserver.kuba.no',
  // Cloudflare Turnstile site key for the anonymous deviation form. Must be set before release:
  // without it the form tells the reporter it cannot send reports.
  TURNSTILE_SITE_KEY: ''
};
